import React, { Fragment } from "react";
import { Card, CustomInput, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { Colxx } from "../../../../../../components/common/CustomBootstrap";

const ServicesThumbListView = ({ service, isSelect, onCheckItem }) => {
    function generateRandomColor() {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
        ];
        return arr[Math.floor(Math.random() * arr.length)];
    }
    return (
        <Colxx xxs="12" key={service.id} className="mb-3">
            <Card
                onClick={event => onCheckItem(event, service.id)}
                className={classnames("d-flex flex-row", {
                    active: isSelect
                })}
            >
                <div className="custom-control custom-checkbox pl-1 align-self-center">
                    <CustomInput
                        className="item-check mb-0"
                        type="checkbox"
                        id={`check_${service.id}`}
                        checked={isSelect}
                        onChange={() => { }}
                        label=""
                    />
                </div>
                <img
                    alt={service.title}
                    src={
                        service.imageLink
                            ? service.imageLink
                            : 'https://via.placeholder.com/250x150'
                    }
                    className="list-thumbnail responsive border-0"
                />

                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                    <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                        <p className="w-25 w-sm-100 list-item-heading mb-1 mr-1">
                            {service.title}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.type}
                        </p>

                        {/* <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.displayText}
                        </p>
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.conditions}
                        </p> */}
                        <p className="mb-1 text-muted text-small w-15 w-sm-100 mr-1">
                            {service.currency} {service.priceRangeStart} - {service.currency} {service.priceRangeEnd}
                        </p>
                        <p className="mb-1 text-small w-20 w-sm-100 mr-1">
                            {service.categories.map((cat, index) => {
                                return (
                                    <Fragment key={`badge_${index}`}>
                                        {' '}
                                        <Badge color={generateRandomColor()} className="mt-1">{cat}</Badge>{' '}
                                    </Fragment>
                                );
                            })}
                        </p>
                    </div>
                </div>
            </Card>
        </Colxx>
    )
}
export default ServicesThumbListView;